import React from 'react';
import * as RadixDropdown from '@radix-ui/react-dropdown-menu';

import styles from './DropdownMenu.module.css';

export const DropdownMenu = RadixDropdown.Root;
export const DropdownMenuTrigger = RadixDropdown.Trigger;

export type DropdownMenuContentProps = React.ComponentPropsWithoutRef<
  typeof RadixDropdown.Content
>;

export const DropdownMenuContent = React.forwardRef<
  React.ElementRef<typeof RadixDropdown.Content>,
  DropdownMenuContentProps
>(({ className, sideOffset = 6, ...props }, ref) => (
  <RadixDropdown.Portal>
    <RadixDropdown.Content
      ref={ref}
      sideOffset={sideOffset}
      className={[styles.content, className].filter(Boolean).join(' ')}
      {...props}
    />
  </RadixDropdown.Portal>
));
DropdownMenuContent.displayName = 'DropdownMenuContent';

export type DropdownMenuItemProps = React.ComponentPropsWithoutRef<typeof RadixDropdown.Item>;

export const DropdownMenuItem = React.forwardRef<
  React.ElementRef<typeof RadixDropdown.Item>,
  DropdownMenuItemProps
>(({ className, ...props }, ref) => (
  <RadixDropdown.Item
    ref={ref}
    className={[styles.item, className].filter(Boolean).join(' ')}
    {...props}
  />
));
DropdownMenuItem.displayName = 'DropdownMenuItem';

export type DropdownMenuSeparatorProps = React.ComponentPropsWithoutRef<
  typeof RadixDropdown.Separator
>;

export const DropdownMenuSeparator = React.forwardRef<
  React.ElementRef<typeof RadixDropdown.Separator>,
  DropdownMenuSeparatorProps
>(({ className, ...props }, ref) => (
  <RadixDropdown.Separator
    ref={ref}
    className={[styles.separator, className].filter(Boolean).join(' ')}
    {...props}
  />
));
DropdownMenuSeparator.displayName = 'DropdownMenuSeparator';

export type DropdownMenuLabelProps = React.ComponentPropsWithoutRef<typeof RadixDropdown.Label>;

export const DropdownMenuLabel = React.forwardRef<
  React.ElementRef<typeof RadixDropdown.Label>,
  DropdownMenuLabelProps
>(({ className, ...props }, ref) => (
  <RadixDropdown.Label
    ref={ref}
    className={[styles.label, className].filter(Boolean).join(' ')}
    {...props}
  />
));
DropdownMenuLabel.displayName = 'DropdownMenuLabel';
